import React from 'react';
import {
  Checkbox,
  Grid,
  SvgIconProps,
  Typography,
  makeStyles,
} from '@material-ui/core';
import clsx from 'clsx';
import CheckIcon from '@material-ui/icons/Check';
import i18n from 'i18n';
import styles from './styles';

const useStyles = makeStyles(styles);

interface SelectorOptionButtonProps {
  name: string;
  labelKey: string;
  selectedItem: string;
  newTag?: boolean;
  icon?: (props: SvgIconProps) => JSX.Element;
  onChange: React.Dispatch<React.SetStateAction<string>>;
}

const SelectorOptionButton = ({
  name,
  labelKey,
  selectedItem,
  newTag,
  icon: Icon,
  onChange,
}: SelectorOptionButtonProps) => {
  const classes = useStyles();
  const isSelected = selectedItem === name;

  return (
    <Grid
      item
      className={clsx(classes.options, {
        [classes.optionsSelected]: isSelected,
      })}
      onClick={() => onChange(name)}
    >
      <Checkbox
        onChange={() => onChange(name)}
        checked={isSelected}
        id={`${name}-graph`}
        icon={<CheckIcon className={classes.ghostCheckIcon} />}
        checkedIcon={<CheckIcon className={classes.checkIcon} />}
      />
      <Typography
        className={clsx(classes.activeAllText, {
          [classes.optionTextSelected]: isSelected,
          [classes.optionTextNewTag]: newTag,
          [classes.optionTextNewTagSelected]: newTag && isSelected,
          [classes.optionTextNewTag]: newTag && !isSelected,
        })}
      >
        {i18n.t(labelKey)}
      </Typography>
      {Icon && (
        <Icon
          className={clsx(classes.activeAllText, {
            [classes.optionTextSelected]: isSelected,
          })}
        />
      )}
      {newTag && (
        <Grid className={classes.ribbon}>
          <Typography className={classes.newTagText}>
            {i18n.t('NEW_KEY')}
          </Typography>
        </Grid>
      )}
    </Grid>
  );
};
export default SelectorOptionButton;
